import { render, staticRenderFns } from "./ValorReferenciaIndicador.vue?vue&type=template&id=e8b7d152&scoped=true"
import script from "./ValorReferenciaIndicador.vue?vue&type=script&lang=js"
export * from "./ValorReferenciaIndicador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b7d152",
  null
  
)

export default component.exports